import {jam} from '@jam.dev/sdk';

import {selectUser} from '~redux/reducers/userReducer';
import {store} from '~redux/index';

let jamInitialized = false;

export function initJam(): void {
  if (jamInitialized || typeof window === 'undefined') {
    return;
  }
  jamInitialized = true;

  jam.metadata(() => {
    const user = selectUser(store.getState());

    return {
      deploymentEnv: import.meta.env.VITE_DEPLOYMENT_ENV ?? '',
      authApi: import.meta.env.VITE_AUTH_API ?? '',
      url: window.location.href,
      userId: user?.userId ?? null,
      email: user?.email ?? null,
      customer: user?.customer ?? null,
      projectId: user?.currentProjectId ?? null,
    };
  });
}
